export default __webpack_public_path__ + "static/media/char_head_prem_016.fd0bca83.png";